import {useState} from "react";
import CompanyIcon from "../assets/company.svg";
import TeamIcon from "../assets/team.svg";
import PersonIcon from "../assets/person.svg";
import IsometricButton from "../base-components/IsometricButton";

function Audience() {

    const [audienceTargets, setAudienceTargets] = useState([
        {
            id: "0",
            name: "AZIENDE",
            icon: CompanyIcon,
            isSelected: true,
            description: "Traid supporta istituzioni finanziarie con strumenti avanzati di analisi basati su AI, integrabili nei processi decisionali interni. La piattaforma offre insight chiari e spiegabili, migliorando efficienza, monitoraggio dei mercati e capacità strategica.",
        },
        {
            id: "1",
            name: "TEAM",
            icon: TeamIcon,
            isSelected: false,
            description: "Progettata per team finanziari e reparti di analisi, Traid facilita la collaborazione offrendo dashboard, indicatori e report condivisibili. Il team ottiene una visione coerente dei mercati e può prendere decisioni in modo più rapido, informato e coordinato.",
        },
        {
            id: "2",
            name: "PRIVATI",
            icon: PersonIcon,
            isSelected: false,
            description: "Traid rende l’intelligenza artificiale accessibile anche a investitori individuali, offrendo analisi trasparenti e spiegabili. L’utente può comprendere meglio il mercato e prendere decisioni in autonomia e con maggiore consapevolezza.",
        }
    ])

    const selectedDescription = audienceTargets.find(aT => aT.isSelected).description

    const handleChangeAudienceTarget = (aTid) => {
        setAudienceTargets(prev => prev.map(aT => aT.id === aTid ? {...aT, isSelected: true} : {
            ...aT,
            isSelected: false
        }))
    }

    return (
        <section aria-label="Audience section" className="relative h-full px-[4vw] mt-[5vw]">
            <div className="flex flex-col w-full items-center gap-[10vw]
                            lg:flex-row
                            lg:items-start">
                <div className="flex flex-col w-full items-center>
                                lg:w-1/3">
                    <div className="flex flex-col text-center gap-[5vw]
                                    lg:text-start">
                        <div className="flex flex-col -space-y-[4vw]">
                            <p className="text-light text-[6vw] font-[900]">ANALISI</p>
                            <p className="text-light text-[6vw] font-[900]">ACCESSIBILI</p>
                            <p className="text-light text-[6vw] font-[900]">A TUTTI</p>
                        </div>
                        <div className="flex flex-row justify-center">
                            <a
                                href="https://traid.it"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <div className="scale-75
                                                sm:scale-[0.85]
                                                4xl:scale-100">
                                    <IsometricButton sideColor="#DC2626" bottomColor="#F0F0F0" backgroundColor="#10B981" textColor="#F0F0F0"  />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row w-full gap-[4vw] min-h-[55vw]
                                lg:min-h-[40vw]
                                lg:flex-col
                                lg:w-2/3">
                    <div className="flex flex-col gap-[5vw] w-1/2 justify-center h-full
                                lg:gap-[1.5vw]
                                lg:w-full">
                        {audienceTargets.map(aT =>
                            <div key={aT.id} className="flex flex-row
                                                        lg:justify-end">
                                <button
                                    className={`${aT.isSelected ? "bg-green" : "bg-light"} rounded-full flex justify-between px-[2vw] py-[0.5vw] items-center border-2 border-black w-full
                                                lg:py-0
                                                lg:w-1/2`}
                                    onClick={() => handleChangeAudienceTarget(aT.id)}>
                                    <span className={`font-[900] ${aT.isSelected ? "text-light" : "text-black"} text-[5.5vw] lg:text-[3vw]`}>{aT.name}</span>
                                    <img src={aT.icon} alt="Tennis Icon" className="h-[10vw] lg:h-[4vw]"/>
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="flex flex-row w-1/2 h-full
                                    lg:w-full
                                    lg:justify-end">
                        <p className="font-[900] text-light text-[2.8vw] w-full text-right
                                      lg:text-[1.5vw]">{selectedDescription}</p>
                    </div>
                </div>
            </div>

        </section>
    )
}

export default Audience;
